import { render, staticRenderFns } from "./ColorForm.vue?vue&type=template&id=7b86a4ea&scoped=true&"
import script from "./ColorForm.vue?vue&type=script&lang=js&"
export * from "./ColorForm.vue?vue&type=script&lang=js&"
import style0 from "./ColorForm.vue?vue&type=style&index=0&id=7b86a4ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b86a4ea",
  null
  
)

export default component.exports